import React, {
  useEffect,
} from 'react';
import {
  requestPatientPaymentsData,
} from 'pages/Dashboard/pages/Billing/api';
import columns from 'pages/Dashboard/pages/Billing/Payments/columns/paymentsOverview';
import Table from 'core/components/VirtualTable';
import {
  PatientPaymentTransaction,
} from 'pages/Dashboard/pages/Billing/types';
import {
  useMedia,
} from 'core/hooks';
import {
  paymentsEventChannel,
} from 'pages/Dashboard/services/eventChannels';
import {
  OverviewProps,
} from 'pages/Dashboard/pages/Billing/Payments';

export default function PatientPaymentsOverview({
  dateRange,
  searchQuery: patientSearchText,
  tableInstanceRef,
  filterQuery = {},
}: OverviewProps) {
  const { requestMedia } = useMedia();

  useEffect(() => {
    const unsubscribe = paymentsEventChannel.on('onPaymentsDataChanged', () => {
      tableInstanceRef?.current?.refetch?.();
    });
    return () => { unsubscribe(); };
  }, []);

  return (
    <div className="flex min-w-0 flex-1 w-full h-full overflow-y-hidden">
      <Table<PatientPaymentTransaction>
        dataKey="patient-payments"
        instanceRef={tableInstanceRef}
        columns={columns}
        defaultPagination={{
          pageSize: 25,
          pageIndex: 0,
        }}
        skeleton={{ rows: 5 }}
        getData={requestPatientPaymentsData}
        emptySlot="No payments found"
        queryParams={{
          dateRange,
          patientSearchText,
          filterQuery,
          requestMedia,
        }}
        onRowClick={(table, row) => {
          // paymentsEventChannel.emit('onPaymentDialogOpen', {
          //   data: row.original,
          //   defaultDateRange: dateRange,
          // });
        }}
        classes={{
          header: 'px-4',
          scrollContainer: 'justify-center items-center',
          outerRow: '!w-[calc(100%-16px)] left-4',
        }}
      />
    </div>
  );
}
